import { createContext, useCallback, useEffect, useState } from 'react';
import useCities from '../../../../Common/Filters/hooks/useCities';

export const SecurityFiltersContext = createContext();

const currentYear = new Date().getFullYear().toString();
const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');

export const securityFiltersInitialState = {
    cidade: {
        value: '',
        label: 'Todas',
        governance_room_client_city_id: null,
        governance_room_geo_city_id: null
    },
    unidade: {
        value: '',
        label: 'Todos'
    },
    year: { value: currentYear, label: currentYear }, 
    month: { value: '', label: 'Todos' },
    location: ''
};

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const SecurityFiltersProvider = ({ children, initialState }) => {
    const [filters, setFilters] = useState(() => {
        const state = initialState || securityFiltersInitialState;

        const savedCity = localStorage.getItem('dashboard_city');

        return savedCity ? { ...state, cidade: JSON.parse(savedCity) } : state;
    });
    const { data: cities } = useCities();

    const handleChangeFilters = (values) => {
        setFilters(values);
    };

    const resetFilters = () => {
        setFilters((previous) => ({
            ...(initialState || securityFiltersInitialState),
            cidade: previous.cidade
        }));
    };

    function getMonthlabel(monthValue) {
        const monthIndex = parseInt(monthValue, 10) - 1;
        return monthNames[monthIndex] || '';
    }

    const onFilterChange = useCallback((name, value) => {
        const nextFilters = {
            ...filters,
            [name]: value,
            ...(name === 'cidade' ? { unidade: { value: '', label: 'Todos' } } : {})
        };

        if (name === 'year' && value?.value === '') {
            nextFilters.month = { value: filters.month?.value || currentMonth, label: getMonthlabel(filters.month?.value || currentMonth) };
        }

        if (name === 'month' && value?.value === '') {
            nextFilters.year = { value: filters.year?.value || currentYear, label: filters.year?.value || currentYear };
        }

        const isYearAllSelected = nextFilters.year?.value === '';
        const isMonthAllSelected = nextFilters.month?.value === '';

        if (isYearAllSelected && isMonthAllSelected) {
            return;
        }

        console.log("🚀 ~ SecurityFiltersProvider ~ nextFilters:", nextFilters)
        handleChangeFilters(nextFilters);
    }, [filters]);

    useEffect(() => {
        if (cities && cities.length > 0 && !filters.cidade.value) {
            onFilterChange('cidade', cities[0]);
        }
    }, [cities, filters.cidade.value, onFilterChange]);

    useEffect(() => {
        if (filters.cidade.value) {
            localStorage.setItem(
                'dashboard_city',
                JSON.stringify(filters.cidade)
            );
        }
    }, [filters.cidade]);

    return (
        <SecurityFiltersContext.Provider
            value={{
                filters,
                handleChangeFilters,
                resetFilters,
                onFilterChange,
                cities: cities || []
            }}
        >
            {children}
        </SecurityFiltersContext.Provider>
    );
};

export default SecurityFiltersProvider;
